export default __webpack_public_path__ + "static/media/img-0246-afghanistan-full-face.4ceef61c.png";